<div *ngIf="(loading$ | async)?.isLoading"
     class="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 dark:bg-black/60"
     role="dialog"
     aria-modal="true"
     aria-labelledby="loading-message">
  <div class="bg-white dark:bg-[#1C1A23] rounded-2xl shadow-2xl p-8 max-w-sm mx-4 border border-gray-200 dark:border-gray-700 animate-scale-in">
    <div class="flex flex-col items-center space-y-6">
      <!-- Spinner -->
      <div class="relative">
        <div class="w-16 h-16 border-4 border-[#F3B02E] border-t-transparent rounded-full animate-spin"></div>
        <!-- Ícone centralizado opcional -->
        <div *ngIf="(loading$ | async)?.icon"
             class="absolute inset-0 flex items-center justify-center">
          <lucide-icon
            [name]="(loading$ | async)?.icon || 'loader-2'"
            class="text-[#F3B02E] w-6 h-6 animate-pulse"
            [strokeWidth]="2.5">
          </lucide-icon>
        </div>
      </div>

      <!-- Mensagem -->
      <p id="loading-message"
         class="text-gray-900 dark:text-white text-center font-medium text-base leading-relaxed">
        {{ (loading$ | async)?.message }}
      </p>
    </div>
  </div>
</div>
